const sectionThemes = {
	'LIGHT'       : 'light',
	'CMORE'        : 'cmore',
};

export default sectionThemes;


// WEBPACK FOOTER //
// ./src/ui/sectionThemes.js